export default "__VITE_ASSET__BYk40msY__"